import DropdownInput from "commonComponents/DropdownInput";
import { fetchCompanyList } from "components/companyList/redux/dispatcher";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  fetchMachineList,
  fetchMachineListByCompanyId,
} from "../redux/dispatcher";
import MultiSelectDropdown from "commonComponents/MultiSelectDropdown";
import PDFViewer from "./PDFViewer";
import { useReactToPrint } from 'react-to-print';

function QRCodeModal({ setQrCodeGeneratorView }) {
  const [modal, setModal] = useState(true);
  const toggle = () => {
    setModal(!modal);
    setQrCodeGeneratorView(false);
  };
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [filteredMachineListByCompnay, setFilteredMachineList] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState([]);
  const [qrPerPage, setQrPerPage] = useState(1);
  const [pages, setPages] = useState([]);

  // useEffect(() => {
  //   const length=selectedMachine.length>=8?8:selectedMachine.length/2+1;
  //   setQrPerPage();
  // }, [selectedMachine]);

  const dispatch = useDispatch();
  const companyListData = useSelector(
    (state) => state?.companyListReducer?.data?.data
  );
  const machineList = useSelector(
    (state) => state.machineListReducer?.machineListDataCompanyId || []
  );

  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchMachineListByCompanyId(selectedCompany));
  }, [selectedCompany]);

  useEffect(() => {
    if (selectedCompany && machineList) {
      setFilteredMachineList(
        machineList.map((machine) => ({
          name: machine.name,
          id: String(machine.machine_id),
          serial_number: String(machine.serial_number),
          tankSize: machine.tank_size,
        }))
      );
      setSelectedMachine([]); // Reset selectedMachine when company changes
    }
  }, [selectedCompany, machineList]);

  useEffect(() => {
    console.log(machineList);
  }, [machineList]);

  // useEffect(() => {
  //   // Split machines into pages
  //   const pages = [];
  //   const machines = getFromatedSelectedMachine();
  //   for (let i = 0; i < machines.length; i += qrPerPage) {
  //     console.log(machines[i]);
  //     pages.push(machines.slice(i, i + qrPerPage));
  //   }
  //   setPages(pages);
  // }, [selectedCompany,selectedMachine, qrPerPage]);
  useEffect(() => {
    const machines = getFromatedSelectedMachine();
    const pages = [];
    for (let i = 0; i < machines.length; i += Math.min(qrPerPage, machines.length - i)) {
      pages.push(machines.slice(i, i + Math.min(qrPerPage, machines.length - i)));
    }
    setPages(pages);
  }, [selectedCompany, selectedMachine, qrPerPage]);

  const getFromatedSelectedMachine = () => {
    return filteredMachineListByCompnay.filter((machine) =>
      selectedMachine.includes(machine.id)
    );
  };

  const pdfViewerRef = useRef(null);

  const handlePrint = useReactToPrint({
    documentTitle: 'Machine QR Codes',
    contentRef: pdfViewerRef,
  })

  return (
    <Modal
      isOpen={modal}
      size="lg"
      toggle={toggle}
      className={`custom-right-modal ${modal ? "show" : ""}`}
    >
      <ModalHeader toggle={toggle}>Generate QR Code of Machines</ModalHeader>
      <ModalBody
        className="d-flex flex-column align-items-center px-4"
        style={{ gap: 20 }}
      >
        <div className="w-100 d-flex align-items-center" style={{ gap: 8 }}>
          <DropdownInput
            options={companyListData.map((data) => ({
              id: data.id,
              name: data.company_name,
            }))}
            value={selectedCompany || ""}
            setValueChange={setSelectedCompany}
            labelText="Select Company"
            mandetory={true}
            styleProp={{
              width: "100%",
              fontSize: "14px",
            }}
          />
          <MultiSelectDropdown
            options={filteredMachineListByCompnay}
            labelText={"Select Machine"}
            mandetory={true}
            onSelectChange={setSelectedMachine}
            styleProp={{
              width: "100%",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="w-100 d-flex justify-content-between px-2 py-3 border rounded bg-lgith-gray">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: 8 }}
          >
            <label htmlFor="qrPerPage" className="font-weight-bold">
              QR Codes per page:
            </label>
            <select
              id="qrPerPage"
              value={qrPerPage}
              onChange={(e) => setQrPerPage(Number(e.target.value))}
              className="border rounded p-2 bg-white"
            >
              <option value="1">1 (Large)</option>
              <option value="2">2 (Large)</option>
              <option value="4">4 (Medium)</option>
              <option value="6">6 (Medium)</option>
              <option value="8">8 (Small)</option>
              <option value="9">9 (Small)</option>
            </select>
          </div>
          <Button
            color="primary"
            onClick={handlePrint}
            className="d-flex align-items-center"
            style={{ gap: 3 }}
          >
            <i className="fa fa-print"></i>
            <span>Print QR Codes</span>
          </Button>
        </div>
        <div ref={pdfViewerRef}>
          <PDFViewer pages={pages} qrPerPage={qrPerPage} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default QRCodeModal;
